import { observeElement } from '@uvocore-front/utils';
/* eslint-disable comma-dangle, no-new */
import UniversitiesCarouselAnimation from './UniversitiesCarouselAnimation';
import './style.scss';

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.universities-section__list')) {
    observeElement({
      element: '.universities-section__list',
      marginValue: 200,
      callback: () => {
        new UniversitiesCarouselAnimation({
          carouselContainer: document.querySelector('.universities-section__inner'),
          carouselContainerClass: 'universities-section__inner',
          carouselItemsListClass: '.universities-section__list',
        });
      }
    });
  }
});
